import { Container, Grid, Typography } from '@material-ui/core'
import styled, { css } from 'styled-components'
import { rem } from '../../utils/rem'
import { CardDesignItem } from '../../components/CardDesignCarousel/CardDesignItem'
import { Breadcrumbs } from '../../components/breadcrumbs/Breadcrumbs'
import {
  StyledCarouselItemContainer,
  StyledLinkTitle,
} from '../../components/CardDesignCarousel/styledCardDesignCarousel'

export const StyledSectionWrapper = styled(Grid)`
> section {
  width: 100%;
}
`

export const StyledArticleWrapper = styled.div<{ $loading?: boolean }>`
  transition: opacity 0.2s ease-in-out;
  opacity: 1;
  will-change: opacity;

  ${props => props.$loading && css`
    opacity: 0.3;
  `}
`

export const StyledPageTitle = styled(Typography)`
  font-weight: 500;
  color: ${props => props.theme.palette.text.primary};
  margin-bottom: 0;

  ${props => props.variant === 'h1' && css`
  font-size: ${props => props.theme.typography.pxToRem(30)};
  margin-bottom: ${props => rem(80, props.theme)};
  `}
  ${props => props.variant === 'h2' && css`
  font-size: ${props => props.theme.typography.pxToRem(20)};
  `}
  ${props => props.theme.breakpoints.up('sm')} {
    ${props => props.variant === 'h1' && css`
      margin-bottom: 0;
    `}
  }

  ${props => props.theme.breakpoints.up('md')} {
    ${props => props.variant === 'h1' && css`
      font-size: ${props => props.theme.typography.pxToRem(38)};
    `}

    ${props => props.variant === 'h2' && css`
      margin-top: ${props => props.theme.typography.pxToRem(64)};
      font-size: ${props => props.theme.typography.pxToRem(24)};
    `}
  }
`

export const StyledBreadcrumbs = styled(Breadcrumbs)`
  margin-bottom: ${props => rem(30, props.theme)};

  ${props => props.theme.breakpoints.up('sm')} {
    margin-bottom: ${props => rem(50, props.theme)};
  }

  ${props => props.theme.breakpoints.up('md')} {
    margin-bottom: ${props => rem(130, props.theme)};
  }
`

export const StyledNewsTitle = styled(Typography)`
  display: none;

  ${props => props.theme.breakpoints.up('sm')} {
    display: block;
    font-weight: 500;
    margin-bottom: ${props => rem(80, props.theme)};
  }

`
export const StyledFiltersGrid = styled(Grid)`
  width: 100%;
  margin-bottom: ${props => rem(60, props.theme)};

  ${props => props.theme.breakpoints.up('sm')} {
    margin-bottom: ${props => rem(150, props.theme)};
  }
`

export const StyledNewsContainer = styled(Grid)`
  display: flex;
  flex-direction: column;
`

export const StyledFeaturedArticlesContainer = styled(Container)`
  margin-top: ${props => rem(80, props.theme)};
  
  ${props => props.theme.breakpoints.up('md')} {
    margin-top: ${props => rem(120, props.theme)};
  }
`

export const StyledBgContainer = styled.div`
  position: relative;
  margin-top: ${props => rem(80, props.theme)};
  padding-top: ${props => rem(40, props.theme)};

  &::before {
    content: "";
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #f8f8f8;
    position: absolute;
    z-index: -1;
    background: linear-gradient(to bottom, #f8f8f8 calc(100% - 500px), #ffffff 100%);
  }

  ${props => props.theme.breakpoints.up('sm')} {
    margin-top: ${props => rem(80, props.theme)};
    padding-top: ${props => rem(80, props.theme)};
  }

  ${props => props.theme.breakpoints.up('md')} {
    margin-top: ${props => rem(120, props.theme)};
    padding-top: ${props => rem(120, props.theme)};
  }
`

export const StyledNewsItem = styled(Grid)`
  display: flex;
  align-items: stretch;
    
  ${StyledCarouselItemContainer} {
    display: flex;
    flex-direction: column;
    justify-content: stretch;
  }

  ${StyledLinkTitle} {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
      
    ${props => props.theme.breakpoints.up('sm')} {
      height: 100%;
    }
  }
`

export const StyledCardWrapper = styled(CardDesignItem)`
  padding: 0;
  width: 100%;
  margin: 0;

  &::after {
    left: 0;
    bottom: 0;
    transform: translateY(100%);
    width: 100%;
    background: #f2f2f2;
    margin-left: 0;
  }
`

export const StyledButtonGrid = styled(Grid)`
  margin-top: ${props => rem(60, props.theme)};
  margin-bottom: ${props => rem(72, props.theme)};

  ${props => props.theme.breakpoints.up('md')} {
    margin: ${props => rem(120, props.theme)} 0;
  }
`

export const StyledHeaderWrapper = styled(Grid)`
  padding-left: 0;
`

export const PopularGuidesAndArticlesWrapper = styled(Container)`
  margin-top: ${props => rem(90, props.theme)};

  ${props => props.theme.breakpoints.up('md')} {
    margin-top: ${props => rem(160, props.theme)};
  }
`
